import React, { useEffect, useRef } from "react";
import { useFetcher } from "../../components/api";
import { DateFilter } from "./DateFilter";
import { Container, Divider, Grid } from "@material-ui/core";
import { DashPanel } from "./DashPanel";
import { useSpiRTCContext } from "../../components/spi-rtc";
import { Pivot } from "../../models/pivot";
import { GraficoEvolucao } from "../../charts/GraficoEvolucao";

interface GetEvolucaoResponse {
  graficos: Pivot[];
  horaTotalizacao: string;
}

export const EvolucaoPage = () => {
  const tipoPeriodoGrafico = "mensal";
  const filtro = new Date();

  const { response, mutate } = useFetcher<GetEvolucaoResponse>(
    `evolucao/${tipoPeriodoGrafico}?dataref=${filtro
      .toLocaleDateString("pt-BR")
      .split("/")
      .reverse()
      .join("-")
      .substring(0, 10)}`,
  );

  const { hub } = useSpiRTCContext();
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (hub) {
      hub.on("vendaTotalizada", () => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => mutate(), 500);
      });
    }
    return () => {
      hub?.off("vendaTotalizada");
      clearTimeout(debounceRef.current);
    };
  }, [hub, mutate]);

  const pivots = response?.data.graficos ?? [];

  const titleMap: { [id: string]: string } = {
    combustiveis: "Combustíveis",
    gruposProdutos: "Grupos de Produtos",
    vendedores: "Vendedores",
    empresas: "Empresas",
  };

  return (
    <div>
      <DateFilter
        dataAtualizacao={
          response?.data?.horaTotalizacao
            ? new Date(response.data.horaTotalizacao)
            : undefined
        }
      ></DateFilter>
      <Divider style={{ margin: "4px -8px" }} />
      <Container
        maxWidth={false}
        style={{ paddingTop: "12px", paddingBottom: "20px" }}
      >
        <Grid container spacing={3}>
          {pivots.map((x) => (
            <Grid key={x.id} item lg={6} md={6} xl={6} xs={12}>
              <DashPanel title={titleMap[x.id] ?? x.id}>
                <GraficoEvolucao medida="count" pivot={x} />
              </DashPanel>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};
